import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { IoMdArrowRoundDown, IoMdArrowRoundUp } from "react-icons/io";
import { FiPlus, FiSearch, FiEdit2 } from "react-icons/fi";
import { RiDeleteBinLine } from "react-icons/ri";
import { BsThreeDotsVertical } from "react-icons/bs";
import { GoFilter } from "react-icons/go";
import {
  useGetAllProductsQuery,
  useDeleteProductMutation,
} from "../redux/services/products";
import { useGetAllUsersQuery } from "../redux/services/profile";
import { useGetAllCategoriesQuery } from "../redux/services/categories";
import { useGetAllProductTypeQuery } from "../redux/services/product_type";
import toggleOn from "../assets/icons/toggle-on-icon.svg";
import toggleOff from "../assets/icons/toggle-off-icon.svg";
import Pagination from "./pagination";
import { createClient } from "../utils/supbase/client";
import DeleteProductModal from "./admin-delete-product-modal";
import Loader from "./Loader";

const UserListingTable = () => {
  const supabase = createClient();
  const [sortOrder, setSortOrder] = useState("asc");
  const [searchQuery, setSearchQuery] = useState("");
  const [modal, setModal] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const pageLimit = 10;
  const offset = (pageNumber - 1) * pageLimit;
  const [totalItems, setTotalItems] = useState();
  const [selectedProduct, setSelectedProduct] = useState(null);
  const navigate = useNavigate();

  const {
    data: users,
    error,
    isFetching: isLoading,
  } = useGetAllUsersQuery({
    offset: offset,
    pageLimit: pageLimit,
  });

  const handlePageChange = (page) => {
    setPageNumber(page);
  };

  const handleSearch = (e) => setSearchQuery(e.target.value.toLowerCase());

  const filteredUsers =
    users?.filter(
      (user) =>
        user?.user_name.toLowerCase().includes(searchQuery) ||
        user?.email.toLowerCase().includes(searchQuery)
    ) || [];

  return (
    <div className="container mx-auto py-4 px-0">
      <div className="flex justify-between items-center mb-4 gap-2">
        <div className="relative md:w-[464px]">
          <FiSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-[#9D9EA1]" />
          <input
            type="text"
            placeholder="Search"
            value={searchQuery}
            className="border px-10 py-1 rounded-lg w-full h-[48px] bg-[#F1F3F9] placeholder-[#9D9EA1]"
            onChange={handleSearch}
          />
        </div>
      </div>

      <div className="md:overflow-visible md:max-h-none overflow-y-auto max-h-[400px]">
        <table className="min-w-full border-separate border border-[#F1F3F9] rounded-lg border-spacing-y-0">
          <thead className="bg-[#F9FAFB]">
            <tr className="border-b border-[#F1F3F9] text-[#484E5A] text-sm">
              <th className="p-2 text-left">Name</th>
              <th className="p-2 text-left">Email</th>
              <th className="p-2 text-left">Role</th>
              {/* <th className="p-2 text-left">Wishlist</th> */}
            </tr>
          </thead>
          <tbody>
            {filteredUsers.length === 0 ? (
              <tr>
                <td colSpan="100%">
                  <div className="flex justify-center items-center py-4 text-gray-500">
                    No data found
                  </div>
                </td>
              </tr>
            ) : (
              filteredUsers.slice(offset, offset + pageLimit).map((user) => (
                <tr key={user.id} className="border-b border-[#F1F3F9] text-sm">
                  <td className="p-2">{user.user_name}</td>
                  <td className="p-2">{user.email}</td>
                  <td className="p-2">{user.role}</td>
                  {/* <td className="p-2">
                    {user.wishlist.length > 0
                      ? user.wishlist
                          .map((item) => `Product ID: ${item.product_id}`)
                          .join(", ")
                      : "No items"}
                  </td> */}
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <Pagination
        currentPage={pageNumber}
        totalItems={filteredUsers.length}
        itemsPerPage={pageLimit}
        onPageChange={handlePageChange}
      />
    </div>
  );
};

export default UserListingTable;
